export const COMPANY_NAME = "DPTO-M INC.";
export const COMPANY_SHORT = "DPTO-M";
export const COMPANY_INITIALS = "DM";
export const COMPANY_ADDRESS_FULL = "1230 Keystone Way, Vista, California, US 92081-8316";
export const COMPANY_LOCATION = "Vista, CA";
export const COMPANY_REGION = "San Diego County, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=1230%20Keystone%20Way%2C%20Vista%2C%20California%2C%20US%2092081-8316";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Fixtures & equipment procurement" },
  { "label": "Sectors", "value": "Hotels & apartments" },
  { "label": "Based in", "value": "Vista, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "DPTO-M Inc." },
  { "label": "Service focus", "value": "Hotel and apartment fixtures & equipment" },
  { "label": "Location", "value": "Vista, California" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Fixture sourcing", "body": "A practical focus on fixtures for hotel and apartment settings." },
  { "icon": "✦", "title": "Equipment procurement", "body": "Procurement support centered on furnishing and equipment needs." },
  { "icon": "✿", "title": "Hospitality settings", "body": "A directory profile for work associated with hotel fixtures and equipment." },
  { "icon": "❍", "title": "Residential settings", "body": "A directory profile for work associated with apartment fixtures and equipment." },
];
